import { render, staticRenderFns } from "./AppletAccount.vue?vue&type=template&id=6fa6fb4a&scoped=true"
import script from "./AppletAccount.vue?vue&type=script&lang=js"
export * from "./AppletAccount.vue?vue&type=script&lang=js"
import style0 from "./AppletAccount.vue?vue&type=style&index=0&id=6fa6fb4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa6fb4a",
  null
  
)

export default component.exports